import Image from "next/image";

export function LensFlareBackground() {
  return (
    <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/60">
      <div className="absolute -left-10 -top-10 w-[165px] h-[166px] opacity-80">
        <Image
          src="/assets/discover/lens-flare-1.webp"
          width={165}
          height={166}
          alt=""
          className="object-cover w-full h-full"
        />
      </div>
      <div className="absolute right-[40px] -top-20 w-[255px] h-[255px] opacity-20">
        <Image
          src="/assets/discover/lens-flare-2.webp"
          width={255}
          height={255}
          alt=""
          className="object-cover w-full h-full"
        />
      </div>
      <div className="absolute right-[20px] top-[14px] w-[99px] h-[100px] opacity-10">
        <Image
          src="/assets/discover/lens-flare-3.webp"
          width={99}
          height={100}
          alt=""
          className="object-cover w-full h-full"
        />
      </div>
      <div className="absolute right-[20px] bottom-[200px] w-[99px] h-[100px] opacity-10">
        <Image
          src="/assets/discover/lens-flare-3.webp"
          width={99}
          height={100}
          alt=""
          className="object-cover w-full h-full"
        />
      </div>
      <div className="absolute -left-6 bottom-[230px] w-[99px] h-[100px] opacity-10">
        <Image
          src="/assets/discover/lens-flare-3.webp"
          width={99}
          height={100}
          alt=""
          className="object-cover w-full h-full"
        />
      </div>
    </div>
  );
}
